const testIds = {
  common: {
    offers: 'offers',
    pagination: 'pagination',
    productVolumes: {
      addToQueueBtn: 'productVolumesAddToQueueBtn',
      addToCartBtn: 'productVolumesAddToCartBtn',
    },
    getFreeBtn: 'getFreeBtn',
    product: 'product',
    limitedProduct: 'lep',
    limitedProductOutOfStock: 'lepOutOfStock',
    caseMonthlyDesignBtn: 'caseMonthlyDesignBtn',
    caseMonthlyDesignModal: 'caseMonthlyDesignModal',
    caseMonthlyDesignCheckbox: 'caseMonthlyDesignCheckbox',
    addToQueueBtn: 'addToQueueBtn',
    topRightPopup: 'topRightPopup',
    productItem: 'productItem',
    onboardTour: 'onboardTour',
  },
  review: {
    title: 'reviewTitle',
    message: 'reviewMessage',
    likeButton: 'reviewLikeButton',
    dislikeButton: 'reviewDislikeButton',
    replyButton: 'reviewReplyButton',
  },
  replyForm: {
    message: 'replyFormMessage',
    cancelButton: 'replyFormCancelButton',
    submitButton: 'replyFormSubmitButton',
  },
  reply: {
    likeButton: 'replyLikeButton',
    dislikeButton: 'replyDislikeButton',
  },
  banners: {
    aboveHeaderBanner: 'aboveHeaderBanner',
    inviteFriends: 'inviteFriends',
    subscribeNowButton: 'subscribeNowButton',
  },
  layout: {
    header: 'layoutHeader',
    headerNav: 'headerNav',
    search: 'search',
  },
  register: {
    emailSuggestion: 'emailSuggestion',
    linkToLogin: 'linkToLogin',
    linkToRegister: 'linkToRegister',
    linkToReset: 'linkToReset',
    authError: 'authError',
  },
  paymentMethods: {
    creditCard: 'paymentOption-creditCard',
    payPal: 'paymentOption-payPal',
    applePay: 'paymentOption-applePay',
    amazonPay: 'paymentOption-amazonPay',
  },
  productsPage: {
    sidebarFilterItems: 'productsPageSidebarFilterItems',
  },
  thankYouPage: {
    title: 'thankyouPage:title',
    queueCountdownSection: 'thankyouPage:queueCountdownSection',
    addToQueueButton: 'thankyouPage:addToQueueButton',
    upgradePlansSection: 'thankyouPage:upgradePlansSection',
    orderBill: 'thankyouPage:orderBill',
    orderError: 'thankyouPage:orderError',
    subscriptionBill: 'thankyouPage:subscriptionBill',
    bottomInviteLink: 'thankyouPage:bottomInviteLink',
  },
  payment: {
    addProductButton: 'addProductButton',
    caseImagePostponed: 'caseImagePostponed',
    submitButton: 'submitButton',
    forms: {
      shipping: 'shippingForm',
      billing: 'billingForm',
    },
    quickViewButton: 'quickViewButton',
    checkoutButton: 'checkoutButton',
    removeOrderItem: 'removeOrderItem',
    cartSection: {
      title: 'cartSectionTitle',
      subtitle: 'cartSectionSubTitle',
    },
    cartOrderItem: {
      plus: 'cartOrderItemPlus',
      minus: 'cartOrderItemMinus',
      count: 'cartOrderItemCount',
    },
    paymentContentSectionTitle: 'paymentContentSectionTitle',
    disclaimer: 'disclaimer',
    enteredAddressOption: 'enteredAddressOption',
    recommendAddressOption: 'recommendAddressOption',
    useAddressButton: 'paymentUseAddressButton',
    editAddressButton: 'paymentEditAddressButton',
    continueButton: 'paymentContinueButton',
    backButton: 'paymentBackButton',
    couponForm: {
      root: 'paymentCouponForm',
      opener: 'paymentCouponFormOpener',
      error: 'paymentCouponFormError',
      result: 'paymentCouponFormResult',
      clear: 'paymentCouponFormClear',
    },
  },
  giftSubscription: {
    mainButton: 'giftSubscriptionMainButton',
  },
  giftSets: {
    image: 'giftSetsImage',
    title: 'giftSetsTitle',
    banner: 'giftSetsBanner',
    switcher: 'giftSetsSwitcher',
    controls: 'giftSetsControls',
    description: 'giftSetsDescription',
    productItems: 'giftSetsProductItems',
    shortDescription: 'giftSetsShortDescription',
  },
  subscription: {
    extras: {
      sideBarButton: 'extrasSideBarButton',
    },
    smartSearch: {
      tagFilters: 'tagFilters',
      tagFilterElement: 'smartSearchTagFilterElement',
    },
    perfumeOfTheMonth: {
      // potm - perfume of the month
      notes: 'potmNotes',
      header: 'potmHeader',
      timeLine: 'potmTimeLine',
      mainImage: 'potmMainImage',
      valuesBtns: 'potmValuesBtns',
      description: 'potmDescription',
    },
  },
  cancelSubscription: {
    receiveButton: 'cancelSubscription:receiveButton',
    refundButton: 'cancelSubscription:refundButton',
    primaryButton: 'cancelSubscription:primaryButton',
    secondaryButton: 'cancelSubscription:secondaryButton',
  },
  resubscribe: {
    reasonTitle: 'reasonTitle',
    reasonInput: 'reasonInput',
    btnCancelSubscription: 'btnCancelSubscription',
    continueCancellation: 'continueCancellation',
  },
  modal: {
    root: 'modal',
    confirmModal: {
      confirmButton: 'modalConfirmButton',
      cancelButton: 'modalCancelButton',
    },
    dialogModal: {
      button: 'dialogModalButton',
    },
    closeIcon: 'modalCloseIcon',
    goNextBtn: 'modalGoNextButton',
    goBackBtn: 'modalGoBackButton',
    pickDateModal: 'pickDateModal',
    setGiftDateModal: 'setGiftDateModal',
    chooseGiftCardSkinModal: 'chooseGiftCardSkinModal',
    setGiftRecipientInfoModal: 'setGiftRecipientInfoModal',
    chooseGiftCardDeliveryTypeModal: 'chooseGiftCardDeliveryTypeModal',
    somethingWentWrongModal: 'somethingWentWrongModal',
  },
  changeFrequency: {
    option: 'frequencyOption',
  },
  upgrade: {
    options: {
      onePerMonth:'upgradeOnePerMonth',
      twoPerMonth:'upgradeTwoPerMonth',
      threePerMonth:'upgradeThreePerMonth',
      // billing
      monthly: 'upgradeMonthly',
      quarter: 'upgradeQuarter',
      semiAnnual: 'upgradeSemiAnnual',
      annual: 'upgradeAnnual',
    },
    orderButton: 'upgradeOrderNowBtn',
    confirmButton: 'upgradeConfirmBtn',
  },
  skipAMonth: {
    optionButton: 'skipOptionButton',
    confirmButton: 'skipConfirmButton',
  },
  profile: {
    order: 'profileOrder',
    orderProduct: 'profileOrderProduct',
    status: {
      subscription: 'subscriptionStatus',
      nextBillingDate: 'nextBillingDate',
      subscriberSince: 'subscriberSince',
      frequency: 'frequencyStatus',
      plan: 'subscriptionPlanStatus',
      giftCredits: 'giftCredits',
      ecomGiftCredits: 'ecomGiftCredits',
    },
    navigation: {
      container: 'profileNav',
      upgrade: 'profileNavUpgrade',
      unpause: 'profileNavUnpause',
    },
    orderStatusButtons: {
      skip: 'btnSkipMonth',
      unpause: 'btnUnpause',
      unskip: 'btnUnskip',
      changeFrequency: 'btnChangeFrequency',
      cancel: 'btnCancelSubscription',
      upgradePlan: 'btnUpgradeYourPlan',
    },
    personalDataForm: {
      form: 'personalDataForm',
      firstName: 'personalDataFormFirstName',
      lastName: 'personalDataFormLastName',
      email: 'personalDataFormEmail',
      birthday: 'personalDataFormBirthday',
      button: 'personalDataFormButton',
      modal: 'personalDataFormModal',
    },
    billingAndShippingInfo: {
      forms: {
        shipping: 'shippingForm',
        billing: 'billingForm',
        creditCard: 'creditCardForm',
      },
    },
  },
  invite: {
    addFriendsForm: 'addFriendsForm',
    facebookButton: 'facebookButton',
    messengerButton: 'messengerButton',
    googleButton: 'googleButton',
    linkButton: 'linkButton',
    resultSection: 'resultSection',
    leaderBoardSection: {
      root: 'leaderBoardSection',
      table: 'leaderBoardSectionTable',
    },
    friendsSection: {
      root: 'friendsSection',
      list: 'friendsSectionList',
    },
  },
  collection: {
    header: 'collectionHeader',
    title: 'collectionTitle',
    text: 'collectionText',
    video: 'collectionVideo',
  },
  pick: {
    product: 'pickProduct',
    continueButton: 'pickContinue',
  },
  queue: {
    month: 'queueMonth',
    product: 'queueProduct',
    emptyProduct: 'queueEmptyProduct',
    openButton: 'queueOpenButton',
    closeButton: 'queueCloseButton',
  },
  menuQueue: {
    month: 'menuQueueMonth',
    product: 'menuQueueProduct',
    emptyProduct: 'menuQueueEmptyProduct',
    openButton: 'menuQueueOpenButton',
    closeButton: 'menuQueueCloseButton',
  },
  headerNav: {
    tracking: 'tracking',
    help: 'help',
    profile: 'profile',
  },
  closeButton: 'closeButton',
  headerSubNav: {
    main: 'main',
    men: 'men',
    women: 'women',
    fineFragrance: 'fineFragrance',
    perfumes: 'perfumes',
    colognes: 'colognes',
    recommendations: 'recommendations',
    popularInStates: 'popularInStates',
    currPerfumeOfTheMonth: 'currPerfumeOfTheMonth',
    currCologneOfTheMonth: 'currCologneOfTheMonth',
    extras: 'extras',
    horoscope: 'horoscope',
    fragranceFinder: 'fragranceFinder',
    brands: 'brands',
    collections: 'collections',
    collectionsWomen: 'collectionsWomen',
    collectionsMen: 'collectionsMen',
    browseAll: 'browseAll',
    fragranceOfTheMonth: 'fragranceOfTheMonth',
    makeup: 'makeup',
    brand: 'brand',
    makeupCollections: 'makeupCollections',
    ourFavorite: 'ourFavorite',
    skincare: 'skincare',
    wellness: 'wellness',
    bambooCharcoalCollection: 'bambooCharcoalCollection',
    goldCollection: 'goldCollection',
    naturalLipBalms: 'naturalLipBalms',
    bodyMoisturizers: 'bodyMoisturizers',
    handCreams: 'handCreams',
    bodyWash: 'bodyWash',
    bestseller: 'bestseller',
    scentedCandles: 'scentedCandles',
    gifts: 'gifts',
    giftCard: 'giftCard',
    giftSetsMen: 'giftSetsMen',
    giftSet: 'giftSet',
    skincareSets: 'skincareSets',
    giftSubscription: 'giftSubscription',
    allGifts: 'allGifts',
    giftSetsWomen: 'giftSetsWomen',
    giftCards: 'giftCards',
    blog: 'blog',
    candles: 'candles',
  },
  gifts: {
    giftsSubscription: 'giftsSubscription',
    giftsBoxes: 'giftsBoxes',
    giftsCards: 'giftsCards',
  },
  headerNavDrop: {
    rateNeonHeatKit: 'headerNavRateNeonHeatKit',
    getFreeScent: 'headerNavGetFreeScent',
    sendGift: 'headerNavSendGift',
    gifts: 'headerNavGifts',
    giftCard: 'headerNavGiftCard',
    giftSetsMen: 'headerNavGiftSetsMen',
    giftSetsWomen: 'headerNavGiftSetsWomen',
    skincareSets: 'headerNavSkincareSets',
    giftSubscription: 'headerNavGiftSubscription',
  },
  headerUserNav: {
    myQueue: 'headerNavMyQueue',
    tracking: 'headerNavTracking',
    upgradeYourPlan: 'headerNavUpgradeYourPlan',
    upgradePrepaid: 'headerNavUpgradePrepaid',
    unpauseSubscription: 'headerNavUnpauseSubscription',
    subscriptionStatus: 'headerNavSubscriptionStatus',
    resubscribe: 'headerNavResubscribe',
    sendGift: 'headerNavSendGift',
    inviteFriends: 'headerNavInviteFriends',
    retakeQuiz: 'headerNavRetakeQuiz',
    personalInfo: 'headerNavPersonalInfo',
    billingAndShipping: 'headerNavBillingAndShipping',
    changePassword: 'headerNavChangePassword',
    logout: 'headerNavLogout',
  },
  queueWidget: {
    root: 'queueWidget',
    closeButton: 'queueWidgetCloseButton',
  },
}


export default testIds
